import { render, staticRenderFns } from "./DifferentTable.vue?vue&type=template&id=5605e802&scoped=true&"
import script from "./DifferentTable.vue?vue&type=script&lang=js&"
export * from "./DifferentTable.vue?vue&type=script&lang=js&"
import style0 from "./DifferentTable.vue?vue&type=style&index=0&id=5605e802&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605e802",
  null
  
)

export default component.exports